module.exports = __webpack_public_path__ + "static/media/cert2.517e4afe.png";